import React, { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader/root';
import {
  FlashMessage,
  Settings as FlashSettings,
} from 'shared/FlashMessage/FlashMessage';
import { pages } from './pages';
import { Header, Footer } from './layout';
import Providers from 'core/Providers';
import ScrollToTop from 'core/ScrollToTop';
import HotLoader from 'core/HotLoader';
import { UserContextUpdater } from './core/context/user';
import { User } from 'core/context/UserContextHandler';
import { BreakpointProvider } from 'react-socks';
import { Flags } from 'utils/FeatureFlagContainer/FeatureFlagContainer';
import { Router } from './Router';
import { BootstrapUser } from 'types/bootstrap';
import SegmentConsentManager from './segmentConsentManager';
import './main.scss';

export type Props = {
  flags: Flags;
  config: {
    csrfToken: string;
    SEGMENT_API_KEY?: string;
  };
  relayEnvironment: any; // TODO: fix when converted to TS
  bootstrapUser?: BootstrapUser;
  contextUser: User | null;
};

const Main: React.FC<Props> = props => {
  const { config, flags, relayEnvironment, bootstrapUser, contextUser } = props;
  const [flashSettings, renderFeedback] = useState<FlashSettings>(null);

  return (
    <Providers
      config={config}
      flags={flags}
      renderFeedback={renderFeedback}
      relayEnvironment={relayEnvironment}
      user={bootstrapUser}
    >
      <BrowserRouter>
        <BreakpointProvider>
          <UserContextUpdater user={contextUser}>
            <Header user={bootstrapUser} />
            <div className="c-letterbox__main">
              <div className="l-main-content-outer">
                <FlashMessage
                  settings={flashSettings}
                  onHide={() => renderFeedback(null)}
                />
                <main role="main" className="l-main-content">
                  <HotLoader>
                    <ScrollToTop>
                      <Router
                        flags={flags}
                        pages={pages}
                        userToken={bootstrapUser?.userToken}
                      />
                    </ScrollToTop>
                  </HotLoader>
                </main>
              </div>
            </div>
            <Footer />
            <SegmentConsentManager />
          </UserContextUpdater>
        </BreakpointProvider>
      </BrowserRouter>
    </Providers>
  );
};

export default hot(Main);
